module.exports = __webpack_public_path__ + "static/img/hackuci-screenshot.b5cf7f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hackuci-screenshot.png
// module id = 4T+2
// module chunks = 0